export const SHAREPOINT_FILE_EMBED_TYPES = [
  {
    extensions: ['jpg', 'jpeg', 'png'],
    url: '/_layouts/15/embed.aspx?UniqueId=uniqueId',
    icon: 'image_file.svg',
  },
  {
    extensions: ['mp4', 'mov', 'wmv', 'avi'],
    url: '/_layouts/15/embed.aspx?UniqueId=uniqueId',
    icon: 'video_file.svg',
  },
  {
    extensions: ['pdf'],
    url: '/_layouts/15/embed.aspx?UniqueId=uniqueId',
    icon: 'pdf_file.svg',
  },
  {
    extensions: ['doc', 'docx'],
    url: '/_layouts/15/Doc.aspx?sourcedoc={uniqueId}&action=embedview',
    icon: 'word_file.svg',
  },
  {
    extensions: ['ppt', 'pptx'],
    url: '/_layouts/15/Doc.aspx?sourcedoc={uniqueId}&action=embedview',
    icon: 'ppt_file.svg',
  },
  {
    extensions: ['xls', 'xlsx'],
    url: '/_layouts/15/Doc.aspx?sourcedoc={uniqueId}&action=embedview&AllowTyping=True&wdHideHeaders=False&wdDownloadButton=True&wdInConfigurator=True&wdInConfigurator=True',
    icon: 'excel_file.svg',
  },
];

const normalizeSharepointUniqueId = (uniqueId) =>
  typeof uniqueId === 'string' ? uniqueId.replace(/[{}]/g, '') : uniqueId;

export const getSharepointFileEmbedUrl = (webUrl, uniqueId, extension) => {
  const type = SHAREPOINT_FILE_EMBED_TYPES.find((type) =>
    type.extensions.includes(extension)
  );

  if (type) {
    return `${webUrl}${type.url.replace(
      'uniqueId',
      normalizeSharepointUniqueId(uniqueId)
    )}`;
  }

  return null;
};

const SHAREPOINT_FILE_EDIT_EXTENSIONS = ['doc', 'docx', 'xls', 'xlsx'];

export const getSharepointFileEditUrl = (webUrl, uniqueId, extension) => {
  if (!SHAREPOINT_FILE_EDIT_EXTENSIONS.includes(extension)) {
    return getSharepointFileEmbedUrl(webUrl, uniqueId, extension);
  }

  return `${webUrl}/_layouts/15/Doc.aspx?sourcedoc={${normalizeSharepointUniqueId(
    uniqueId
  )}}&action=edit`;
};

export const getSharepointIcon = (extension, childVisible) => {
  if (extension === 'folder') {
    if (childVisible) {
      return 'openfolder_file.svg';
    }
    return 'folder_file.svg';
  }

  const sharepointType = SHAREPOINT_FILE_EMBED_TYPES.find((type) =>
    type.extensions.includes(extension)
  );

  if (sharepointType) {
    return sharepointType.icon;
  }

  return 'file.svg';
};
